import { render } from "./AccountSettings.vue?vue&type=template&id=3a643e2a&scoped=true&ts=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"

import "./AccountSettings.vue?vue&type=style&index=0&id=3a643e2a&lang=scss&scoped=true"
import "./AccountSettings.vue?vue&type=style&index=1&id=3a643e2a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a643e2a"]])

export default __exports__